module.exports = __webpack_public_path__ + "static/media/voting-illust.625b5974.png";